<template>
  <div class="menu">
    <template class="">
      <div class="mobileBk below1200">
        <div class="topnav">
          <MobileMenu />
        </div> 
      </div>
    </template>
    <template class="">
      <div class="topNav above1200">
        <b-container>
          <b-row>
            <b-col>
                <template v-if="$route.name == 'home'">
                  <div class="join">
                    <b-nav-item class='headerNavLink downloadBtn' @click="scroll()">
                      <button class="downloadApp">Join the Clutch Tour</button>
                    </b-nav-item>
                  </div>
                </template>
                <template v-else>
                  <div class="join">
                    <b-nav-item class='headerNavLink downloadBtn' href="https://apps.apple.com/us/app/clutch-pro-tour/id6756672491" target="_blank">
                      <button class="downloadApp">Join the Clutch Tour</button>
                    </b-nav-item>
                  </div>
                </template>
            </b-col>
            <b-col>
              <div class="logoSec">
                <b-link to="/" class="noLines">
                  <img class="MainLogo" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/03/Rapsodo_Series_Clutch_Logo_White_Blue.png">
                </b-link>
              </div>
            </b-col>
            <b-col>
              <div class="RightNav">
                <b-nav-item class='headerNavLink' to="/about">About</b-nav-item>
                <b-nav-item class='headerNavLink' to="/membership">Membership</b-nav-item>
                <b-nav-item class='headerNavLink' to="/portugal-series">Portugal Series</b-nav-item>
                <b-nav-item class='headerNavLink' to="/executive">Executive Club</b-nav-item>
                <!-- <b-nav-item class='headerNavLink' to="/shop">Shop</b-nav-item> -->
                <b-nav-item class='headerNavLink' to="/news">News</b-nav-item>
                <div class="socialROw">
                  <b-row>
                    <b-col lg="1" class="instaCol">
                      <b-link href="https://www.instagram.com/clutchprotour/?hl=en" target="_blank" class="linkClass">
                        <!-- <img class="socialIcon" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Instagram-1.png"> -->
                        <div class="instaImage"></div>
                      </b-link>
                    </b-col>
                    <b-col lg="1" class="facCol">
                      <b-link href="https://www.facebook.com/clutchprogolftour" target="_blank" class="linkClass">
                        <!-- <img class="socialIcon" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Facebook-1.png"> -->
                        <div class="faceBookImage"></div>
                      </b-link>
                    </b-col>
                    <b-col lg="1" class="ticCol">
                      <b-link href="https://www.tiktok.com/@clutchprotour" target="_blank" class="linkClass">
                        <!-- <img class="socialIcon" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/TikTok.png"> -->
                        <div class="ticImage"></div>
                      </b-link>
                    </b-col>
                    <b-col lg="1" class="youCol">
                      <b-link href="https://www.youtube.com/channel/UCS34dfBB8jyD98wSFgrwBoA" target="_blank" class="linkClass">
                        <!-- <img class="socialIcon" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/TikTok.png"> -->
                        <div class="youImage"></div>
                      </b-link>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="secondMenu above1200">
        <b-container>
          <b-row class="secondNav">
            <b-col cols="3" class="colTwel">
              <div class="title above1200">Choose your Clutch Tour:</div>
              <div class="title below1200">Choose Tour:</div>
            </b-col>
            <b-col cols="9" class="colTwel">
              <div id="nav">
                <b-navbar type="dark" toggleable="xl" id="topNav" align="center">
                  <b-navbar-toggle
                    class="ml-auto"
                    type="dark"
                    target="nav-collapse"
                  ></b-navbar-toggle>
                  <b-collapse id="nav-collapse" is-nav>
                    <b-nav-item to="/hotel-planner" class="imageTrophy">
                      <img class="trophyImage" src="https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/el.png">
                    </b-nav-item>
                    <b-nav-item to="/schedule?tour=cpt" :class="{backCol : $route.query.tour == 'cpt'}" class="secondSub t1">Tier 1</b-nav-item>
                    <b-nav-item to="/schedule?tour=cp2" :class="{backCol : $route.query.tour == 'cp2'}" class="secondSub t2">Tier 2</b-nav-item>
                    <b-nav-item to="/schedule?tour=cp3" :class="{backCol : $route.query.tour ==  'cp3'}" class="secondSub am">Amateur</b-nav-item>
                    <b-nav-item to="/schedule?tour=pam" :class="{backCol : $route.query.tour == 'pam'}" class="secondSub prom">Pro-Ams</b-nav-item>
                    <b-nav-item to="/schedule?tour=por" :class="{backCol : $route.query.tour == 'por'}" class="secondSub por">Portugal Series</b-nav-item>
                    <b-nav-item to="/schedule?tour=qsc" :class="{backCol : $route.query.tour == 'qsc'}" class="secondSub qs">Q-School</b-nav-item>
                    <b-nav-item to="/stats" class="secondSub oom">Order Of Merit</b-nav-item>
                    <!-- <b-nav-item to="/exclusive" class="secondSub">Exclusive</b-nav-item> -->
                  </b-collapse>
                </b-navbar>
              </div>         
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
  </div>
</template>
<script>
import apiCall from "@/services/api.js";
import MobileMenu from "@/components/mobileMenu.vue"
import axios from 'axios';
export default {
  name: "Menu",
  props: ["config"],
  components: {
    MobileMenu
  },
  data() {
    return {
      menueLink: "menuLink",
      text: "",
      showModal: false,
      allow_qschool:"",
      oomList: [],
      posts: [],
      video: [],
      showDrop: false
    };
  },
  created() {
    apiCall
    .tmParamsBase()
    .then(({ data }) => {
      this.allow_qschool = data.tm_params.allow_qschool;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      sessionStorage.setItem("showModal", "yes");
    } else {
      sessionStorage.setItem("showModal", "no");
    }
  },
  mounted() {
    // this.myFunctionPlayers();
    // this.myFunctionMedia();
    window.addEventListener('mouseup',function(event){
          var pol = document.getElementById('myDIV');
          if(event.target != pol && event.target.parentNode != pol){
              pol.style.display = 'none';
          }
    });  
    window.addEventListener('mouseup',function(event){
          var pol = document.getElementById('myDIVTwo');
          if(event.target != pol && event.target.parentNode != pol){
              pol.style.display = 'none';
          }
    }); 
    window.addEventListener('mouseup',function(event){
          var pol = document.getElementById('myDIVThree');
          if(event.target != pol && event.target.parentNode != pol){
              pol.style.display = 'none';
          }
    }); 
    const showModal = sessionStorage.getItem("showModal");
    console.log(showModal);
    if (showModal === "yes") setTimeout(() => this.$refs.myModal.show(), 3500);
    let retString = localStorage.getItem("oom")
    let retArray = JSON.parse(retString)
    this.oomList = retArray;
    console.log("retArray");
    console.log(retArray);
    this.$bvModal.hide('myDIV')
    this.menuNews();
    this.getYoutube();
  },
  methods: {
    showDrow: function() {
      var x = document.getElementById("myLinks");
      x.style.display = "none";
    },
    scroll() {
      var score = document.getElementById("download");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    hide: function(obj) {
      var el = document.getElementById(obj);
      el.style.display = 'none';
    },
    // myFunctionPlayers() {
    //   var v = document.getElementById("myDIV");
    //   var m = document.getElementById("myDIVTwo");
    //     if (v.style.display === "none") {
    //         v.style.display = "block";
    //         m.style.display = "none";
    //     } else {
    //         v.style.display = "none";
    //     }
    // },
    // myFunctionMedia() {
    //   var v = document.getElementById("myDIVTwo");
    //   var p = document.getElementById("myDIV");
    //     if (v.style.display === "none") {
    //         v.style.display = "block";
    //         p.style.display = "none";
    //     } else {
    //         v.style.display = "none";
    //     }
    // },
    goSearch() {
      console.log('Go search')
      // this.text = text
      this.$router.push({ name: "search", query: { search: this.text } });
    },
    show() {
      this.showModal = true;
      this.$emit("show-me");
    },
    close() {
      this.showModal = false;
      sessionStorage.setItem("showModal", "no");
      this.$emit("hide-me");
    },
    isMobile() {
        if( screen.width <= 760 ) {
            return true;
        }
        else {
            return false;
        }
    },
    menuNews() {
      const json = "wp/v2/posts?randomadd=" +
            new Date().getTime();
      apiCall
        .wpInfo(json)
        .then(({ data }) => {
          this.posts = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
    getYoutube: function() {
      axios.get(
        'https://api.euro.ocs-software.com/youtube/videos?playlistId=' + 'UC88jp_VEEHXDJzDjAA2lqwg' + '&key=' + 'AIzaSyAmgpLKnjwQS0eueW1RRmGeEpXNMHXgdKg' + '&maxResults=10&type=video&order=date&part=snippet,contentDetails&'
      )
      .then(({ data }) => {
        this.video = data.items;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li.nav-item.imageTrophy {
  margin-right: 13px;
}
img.trophyImage {
  width: 65px;
}
::v-deep li.nav-item.imageTrophy > a {
  background-color: #fff!important;
}
.topnav {
  overflow: hidden;
  background-color: #081C3F;
  position: relative;
}

.topnav #myLinks {
  display: none;
}

.topnav a {
  color: white;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  display: block;
}

.topnav a.icon {
  background: #081C3F;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
}
li.nav-item.secondSub.oom > .router-link-exact-active{
  background-color: #081C3F!important;
  color: #fff!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t1.backCol > .router-link-exact-active{
  background-color: #bceff0!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t2.backCol > .router-link-exact-active{
  background-color: #bde9d8!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.por.backCol > .router-link-exact-active{
  background-color: #c96b6b!important;
  color: #fff!important;
  border-radius: 6px;
}
li.nav-item.secondSub.am.backCol > .router-link-exact-active {
  background-color: #dfc3c2!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.prom.backCol > .router-link-exact-active {
  background: #c3bcce!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.qs.backCol > .router-link-exact-active {
  background-color: #ededc3!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t1.mob > a{
  background-color: #bceff0!important;
  color: #0A0F24!important;
}
li.nav-item.secondSub.t2.mob > a{
  background-color: #bde9d8!important;
  color: #0A0F24!important;
}
li.nav-item.secondSub.por.mob > a{
  background-color: #c96b6b!important;
  color: #fff!important;
}
li.nav-item.secondSub.am.mob > a{
  background-color: #dfc3c2!important;
}
li.nav-item.secondSub.prom.mob > a{
  background: #c3bcce!important;
  color: #0A0F24!important;
}
li.nav-item.secondSub.qs.mob > a{
  background-color: #ededc3!important;
  color: #0A0F24!important;
}
li.nav-item.secondSubS.mob > a {
  color: #fff!important;
  font-weight: bold;
}
li.nav-item.secondSub.t1.backCol{
  background-color: #bceff0!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t2.backCol {
  background-color: #bde9d8!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.por.backCol {
  background-color: #c96b6b!important;
  color: #fff!important;
  border-radius: 6px;
}
li.nav-item.secondSub.am.backCol {
  background-color: #dfc3c2!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.prom.backCol {
  background: #c3bcce!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.qs.backCol {
  background-color: #ededc3!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t1.backCol >a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.t2.backCol >a  {
  color: #0A0F24!important;
}
li.nav-item.secondSub.por.backCol >a  {
  color: #fff!important;
}
li.nav-item.secondSub.am.backCol > a{
}
li.nav-item.secondSub.prom.backCol > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.qs.backCol > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.t1:hover {
  background-color: #bceff0!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t1:hover > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.t2:hover {
  background-color: #bde9d8!important;
  border-radius: 6px;
}
li.nav-item.secondSub.por:hover {
  background-color: #c96b6b!important;
  border-radius: 6px;
}
li.nav-item.secondSub.oom:hover{
  background-color: #081C3F!important;
  color: #fff!important;
  border-radius: 6px;
}
li.nav-item.secondSub.t2:hover > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.por:hover > a{
  color: #fff!important;
}
li.nav-item.secondSub.am:hover > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.am:hover {
  background-color: #dfc3c2!important;
  color: #0A0F24!important;
  border-radius: 6px;
}
li.nav-item.secondSub.prom:hover {
  background: #c3bcce!important;
  border-radius: 6px;
}
li.nav-item.secondSub.prom:hover > a{
  color: #0A0F24!important;
}
li.nav-item.secondSub.qs:hover {
  background-color: #ededc3!important;
  border-radius: 6px;
}
li.nav-item.secondSub.qs:hover > a{
  color: #0A0F24!important;
}
.instaCol.col-lg-1 {
  padding-right: 22px;
}
.ticCol.col-lg-1 {
  margin-right: 8px;
}
.join {
  margin-top: 65px;
}
.logoSec {
  text-align: center;
}
li.nav-item.secondSub {
  margin-right: 13px;
}
li.nav-item.secondSub > a.nav-link.router-link-exact-active.router-link-active {
  /* color: #fff!important; */
}
.headerNavLink > a:hover {
  color: #fff!important;
}
li.nav-item.secondSub:hover {
  background-color: #081C3F;
}
li.nav-item.secondSub:hover > a{
  color: #fff!important;
}
li.nav-item.secondSub > a{
  color: #081C3F;
  font-size: 20px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
li.nav-item.secondSub.backCol {
  background-color: #081C3F;
}
li.nav-item.secondSub.backCol > a {
  color: #fff!important;
}
.title {
  text-align: left;
  background-color: transparent;
  color: #081C3F;
  vertical-align: middle;
  position: relative;
  top: 13px;
  /* font-weight: bold; */
  font-size: 20px;
  /* left: 13px; */
  left: 0px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.secondMenu {
  background-color: #fff;
}
.instaImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Instagram-1.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
}
.instaImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Instagram_Blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
}
.faceBookImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Facebook-1-1.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 10px;
}
.faceBookImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Facebook_BLUE.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 10px;
}
.ticImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/TikTok.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 15px;
}
.ticImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/TikTok_Blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 15px;
}
.youImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/YouTube.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 20px;
  width: 25px;
}
.youImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/YouTube_Blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 20px;
  width: 25px;
}
/* .instaImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/YouTube_Blue.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
}
.faceBookImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Facebook-1-1.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 10px;
} */
/* .ticImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/TikTok.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 18px;
  width: 15px;
}
.youImage:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/YouTube.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 20px;
  width: 25px;
} */
li.nav-item.headerNavLink.downloadBtn {
  padding-left: 0.5em;
  padding-right: 1em;
}
li.nav-item.headerNavLink.downloadBtn > a {
  background-color: #fff;
  color: #081C3F;
  font-weight: bold;
  width: 220px;
  text-align: center;
  border-radius: 26px;
}
li.nav-item.headerNavLink.downloadBtn > a:hover {
  background-color: #081C3F;
  width: 220px;
  text-align: center;
  color: #fff!important;
  border: 1px solid #fff;
  border-radius: 26px;
}
button.downloadApp {
  background-color: transparent;
  border: 0;
  /* color: #081C3F; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 20px;
}
.votePlayerofMonth {
  margin-top: 40px;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 30px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  /* position: absolute; */
  right: 14em;
  margin-top: 0px;
  width: 100%;
  height: 50px;
  margin-bottom: 90px;
  background-color: #1C2335;
  border-color: #1C2335;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
::v-deep div.eapps-widget {
    position: relative;
    top: 3px;
}
::v-deep .eapps-widget-toolbar {
    position: absolute;
    top: -32px;
    left: 0;
    right: 0;
    z-index: 99999;
    padding-bottom: 4px;
    transition: all .3s ease;
    pointer-events: none;
    opacity: 0;
    display: none!important;
}
::v-deep .icon {
  font-size: 17pt!important;
  margin-top: 4px;
}
svg.icon.svg-inline--fa.fa-flickr.fa-w-14 {
  color: #fff;
}
.socialROw {
  /* display: inline-block;
  position: relative;
  top: 3px; */
  float: right;
  margin-top: 30px;
}
button.navbar-toggler.ml-auto.collapsed {
  margin-top: -5.5em;
}
button.navbar-toggler.ml-auto.not-collapsed {
  margin-top: -5.5em;
}
#topNavMob {
  /* position: absolute;
  right: 20px;
  top: 8px; */
}
img.mobLogo {
  width: 90px;
  padding-top: 18px;
  padding-bottom: 18px;
  margin-left: 10px;
}
.mobileBk {
  background-color: #081C3F;
}
::v-deep .box{
  position: relative;
  top: -10px;
}
svg.magGlassIcon.svg-inline--fa.fa-search.fa-w-16 {
  position: absolute;
  top: 13px;
  left: 13px;
}
::v-deep .input {
  padding: 10px;
  width: 45px;
  height: 45px;
  background: none;
  border: 2px solid #263057;
  border-radius: 50px;
  box-sizing: border-box;
  font-size: 20px;
  color: #263057;
  outline: none;
  transition: .5s;
  text-indent: 25px;
}
::v-deep .box:hover input{
  width: 350px;
  background: #fff;
  border-radius: 10px;
}
::v-deep .box i{
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translate(-50%,-50%);
  font-size: 26px;
  color: #263057;
  transition: .2s;
}
::v-deep .box:hover i{
  opacity: 0;
  z-index: -1;
}
/* input::before {
  content:url('https://ams3.digitaloceanspaces.com/ocs-sport/alpstourgolf/2025/02/Search-Icon-1.png');
} */
::v-deep .embed-responsive-16by9::before {
  padding-top: 49.25%;
}
::v-deep .embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.nameSection {
  padding-top: 30px!important;
  height: 170px;
}
.nameSection.one {
  padding-top: 30px!important;
  height: auto;
}
.router-link-exact-active {
  background-color: transparent!important;
}
.oomPos {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: absolute;
  z-index: 999;
  left: 37%;
  right: 37%;
  margin-top: -50px;
  width: 80px;
  height: 80px;
}
.oomPosition {
  position: relative;
  left: 33px;
  /* right: 0; */
  top: 23px;
  font-size: 16pt;
}
.oomWholeSection {
  margin-top: 3em;
}
.oomWholeSectionMedia {
  margin-top: 3em;
  padding-bottom: 3em;
}
.playerBackground {
  height: 230px;
  /* background-position: top; */
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.nameSection {
  background-color: #fff;
  padding: 15px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  color: #081C3F;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding-top: 38px;
  padding-bottom: 30px;
  white-space: nowrap;
  /* width: 50px; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.nameSection > a {
  color: #081C3F!important;
}
.playerSectionBlock {
  margin-top: 7em;
}
.mediaSectionBlock {
  margin-top: 7em;
  text-align: left;
}
.playersSecLine {
  padding-top: 10px;
  padding-bottom: 10px;
}
a.linksPlayers {
  color: #fff!important;
  font-size: 18px;
}
a.linksPlayers:hover {
  color: #081C3F!important;
  text-decoration: none;
  font-size: 18px;
}
.players {
  background-color: #0A0F24;
  color: #fff;
  z-index: 999;
  position: absolute;
  height: 456px;
  width: 100%;
  display: contents;
}
.media {
  background-color: #0A0F24;
  color: #fff;
  z-index: 999;
  position: absolute;
  width: 100%;
  display: contents;
  height: 550px;
}
a.noLines.router-link-exact-active.router-link-active {
  background-color: transparent !important;
}
li.nav-item.headerNavLink {
  position: relative;
  /* right: 5em; */
  right: 0.5em;
}
img.socialIcon {
  /* width: 15px;
  height: 15px; */
  /* width: 20px; */
  height: 18px;
}
.secondNav {
  padding-top: 20px;
  /* padding-bottom: 20px; */
}
::v-deep .headerNavLink > a {
  color: #fff;
  /* margin-right: 2em; */
  margin-right: 0em;
}
::v-deep .headerNavLink > a:last-child {
  /* margin-right: 1.5em; */
  margin-right: 0em;
}
::v-deep .headerNavLink > a:hover {
  color: #00FFFE!important;
}
.RightNav {
  text-align: right;
  position: relative;
  /* top: 25px; */
  top: 33px;
}
img.MainLogo {
  margin-top: 35px;
  width: 300px;
}
.topNav {
  background-color: #081C3F;
  /* height: 100px; */
  /* height: 98px; */
  height: 185px;
}
#mobileLogo {
  position: absolute;
  z-index: 99;
  /* margin-top: 13px; */
  width: 250px;
  max-width: 510px;
  left: 0;
  right: 0;
  margin: auto;
  top: 15px;
  display: none;
}
::v-deep tr:nth-child(even) {
  background-color: #dfe1e6;
}
#socialNav {
  text-align: right;
  position: relative;
  top: 11px;
}

::v-deep .navbar {
  padding: 0px;
}

li.nav-item {
  display: inline-block;
}
::v-deep .nav-link {
  color: white;
  padding: 0.7em 1rem;
}

::v-deep .navbar {
  padding-bottom: 0;
}

::v-deep .navbar-toggler {
  border: 0px;
}

::v-deep .nav-link:hover {
  color: #081C3F !important;
}
.menuS > .nav-link:hover {
  background-color: transparent !important;
}
.menuS > .nav-link {
  padding: 0;
}
.menuS {
  padding: 0 2px;
}
::v-deep .dropdown-item {
  color: #081C3F !important;
  /* background-color: #081C3F; */
}

::v-deep .dropdown-menu {
  color: #081C3F !important;
  /* background-color: #081C3F; */
}

::v-deep .dropdown-item:hover {
  color: #081C3F !important;
  background-color: white;
}

#logo {
  max-width: 510px;
  padding-top: 1%;
}
.logoWrap {
  text-align: center;
}
.icon {
  font-size: 25pt;
}

#fb {
  color: #3b5998;
}

.fa-gradient {
  color: #4c68d7;
}

#twit {
  color: #1da1f2;
}

#yt {
  color: #ff0000;
}

#topNav {

}

::v-deep .nav-link {
  color: #707070 ;
  padding: 0.7em 1rem;
  /* font-size: 18px; */
  font-size: 16px;
}

.menu {
  padding-bottom: 0%;
  box-shadow: 0px 3px 6px #00000029;
  position: relative;
  z-index: 999;
}

.router-link-exact-active {
  background-color: #081C3F!important;
  color: #00FFFE !important;
}
.sIcon {
  color: white !important;
  background-color: #081C3F;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
::v-deep .modal-content {
  border-radius: 17px;
}
::v-deep .modal-body {
  text-align: center;
  background-color: #081C3F;
  color: white;
  border-radius: 15px;
}
.appStore {
  padding: 20px;
}
.form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
::v-deep .dropdown-toggle::after {
  vertical-align: 0.2em;
  font-size: 15px;
}
.navbar-collapse {
  text-align: center;
}
::v-deep .navbar-toggler > span {
  cursor: pointer;
  border-radius: 0px;
  height: 2px;
  width: 35px;
  background: white;
  position: absolute;
  display: block;
  content: "";
  right: 20px;
  transition: all 200ms ease-in-out;
}
::v-deep .not-collapsed > span {
  background-color: transparent;
}
::v-deep .not-collapsed  > span::before {
transform: rotate(-45deg);
    top: 0!important;
}
::v-deep .not-collapsed  > span::after {
    transform: rotate(45deg);
        top: 0;
}
::v-deep .navbar-toggler > span::before {
  cursor: pointer;
  border-radius: 0px;
  height: 2px;
  width: 35px;
  background: white;
  position: absolute;
  display: block;
  content: "";
  top: -10px;
  transition: all 200ms ease-in-out;
}
::v-deep .navbar-toggler > span::after {
  cursor: pointer;
  border-radius: 0px;
  height: 2px;
  width: 35px;
  background: white;
  position: absolute;
  display: block;
  content: "";
  bottom: -10px;
  transition: all 200ms ease-in-out;
}

@media only screen and (max-width: 1335px) {
  ::v-deep .headerNavLink > a {
    color: #fff;
    margin-right: 1em;
  }
  ::v-deep .headerNavLink > a:last-child {
    margin-right: 0;
  }
}

@media only screen and (min-width: 1200px) {
  .searchMobile {
    display: none!important;
  }
  .below1200 {
    display: none;
  }
}

@media only screen and (max-width: 1199px) {
  .above1200 {
    display: none;
  }
  .colTwel.col-8 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  button.navbar-toggler.ml-auto.collapsed {
    /* margin-top: -6.5em; */
    margin-top: -4em;
  }
  button.navbar-toggler.ml-auto.not-collapsed{
    margin-top: -4em;
  }
  ::v-deep .RightNav {
    text-align: right;
    position: relative;
    top: 25px;
    display: none;
  }
  .searchMobile {
    margin-bottom: 30px;
    margin-top: 30px;
    width: 80%;
  }
  #socialNav {
    display: none;
  }
  .navbar-toggler {
    padding: 40px;
  }
  .navbar-collapse>.nav-item{
    display: inline-block;
    padding-bottom: 20px;
  }
  ::v-deep .dropdown-menu {
    position: relative!important;
    top: 100%;
    left: 0;
    z-index: 1000;
    float: none;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: center;
    list-style: none;
    background-color: #1d2441;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    margin: auto;
  }
  ::v-deep .dropdown-item {
    color: white !important;
    background-color: #1d2441;
  }
}
@media only screen and (max-width: 990px) {
  ::v-deep .nav-link {
    color: #fff !important;
    padding: 0.7em 1rem;
    /* font-size: 18px; */
    font-size: 16px;
  }
}
@media only screen and (max-width: 980px) {
  .router-link-exact-active{
    background-color: white;
    color: #f8f8f8 !important;
  }
  #topNav {
    display: none;
  }
  .logoWrap {
    text-align: left;
  }
  .RightNav {
    display: none;
  }
  #topNav {
    background-color: transparent;
  }
  .secondNav {
    padding-top: 20px;
    padding-bottom: 20px;
    display: none;
  }
}
@media only screen and (max-width: 840px) {
  .logoWrap {
    text-align: center;
  }
}
@media only screen and (min-width: 760px) {
  #mobileLogo {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  #logo {
    width: 60%;
    display: none;
  }
  li.nav-item.headerNavLink.downloadBtn.mob {
    padding-left: 4em;
    top: 2px;
  }
}

@media only screen and (max-width: 480px) {
  #nav-collapse {
    padding-left: 0;
  }
  #socialNav {
    position: inherit;
    width: 100%;
    padding: 20px;
  }
  ::v-deep .dropdown-item {
    font-size: 13px;
  }
}
@media only screen and (min-width: 1200px) {
  ::v-deep .navbar-expand-xl .navbar-collapse {
    display: inline-table !important;
    text-align: right;
    background-color: #fff;
  }
}
@media only screen and (max-width: 768px) {
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
  li.nav-item.headerNavLink {
    position: relative;
    /* right: 5em; */
    right: 0;
  }
}
@media only screen and (max-width: 1280px) {
  ::v-deep #sitetran_translate_element {
    display: none;
  }
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0px;
    margin-right: 0px;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
@media only screen and (max-width: 510px) and (min-width: 376px)  {
  li.nav-item.headerNavLink.downloadBtn.mob {
      padding-left: 6em;
      top: 2px;
  }
}
</style>